module.exports = "<div class=\"load-wait\">\r\n    <span class=\"glyphicon glyphicon-repeat fast-right-spinner\"></span> Loading...\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/loadingspinner.html
// module id = 13
// module chunks = 0